import './AdminPanelPage.scss'
import { Link, Routes, Route, NavLink, useNavigate } from 'react-router-dom'
import logoImage from '../../../assets/images/branding/gg_thumbnail.png'
import { useState } from 'react'
import AdminRoute from '../../../HOCs/AdminRoute'
import AdminOrderPage from '../OrderPages/AdminOrderPage/AdminOrderPage'
import { Box } from '@mui/material'
import { SessionManager } from '../../../services/SessionManager/SessionManager'
import AdminPromotionsPage from '../AdminPromotionsPage/AdminPromotionsPage'
import AdminUsersPage from '../AdminUsersPage/AdminUsersPage'
import AdminCategoriesPage from '../AdminCategoriesPage/AdminCategoriesPage'
import AdminOverviewPage from '../AdminOverviewPage/AdminOverviewPage'
import AdminSellerPlansPage from '../AdminSellerPlansPage/AdminSellerPlansPage'
import AdminFeedbackPage from '../AdminFeedbackPage/AdminFeedbackPage'
import AdminChatMonitorPage from '../AdminChatMonitorPage/AdminChatMonitorPage'

const AdminDashboardBase = () => {
  const navigate = useNavigate()
  const [basePaddingDisable, setBasePaddingDisable] = useState(false);

  // const disableBasePadding = () => setBasePaddingDisable(true);
  const enableBasePadding = () => setBasePaddingDisable(false);

  return (
    <div className='admin-panel-page'>
    <section className='admin-dashboard-section'>
      <div className="admin-dashboard-left">
        <Link to={"/"}>
          <div className="logo-box">
            <img src={logoImage} alt="logo" />
            <p>GG-Admin </p>
          </div>
        </Link>
      
        <ul className="tab-box">
          <NavLink end to='' onClick={enableBasePadding}>
            <span><i className="fas fa-chart-line"></i></span>Overview
          </NavLink>
          <NavLink to='users' onClick={enableBasePadding}>
            <span><i className="fas fa-users"></i></span>Users
          </NavLink>
          <NavLink to='orders' onClick={enableBasePadding}>
            <span><i className="fas fa-shopping-cart"></i></span>Orders
          </NavLink>
          <NavLink to='promotions' onClick={enableBasePadding}>
            <span><i className="fas fa-tags"></i></span>Promotions
          </NavLink>
          <NavLink to='seller-plans' onClick={enableBasePadding}>
            <span><i className="fas fa-briefcase"></i></span>Seller Plans
          </NavLink>
          <NavLink to='category-subcategory' onClick={enableBasePadding}>
            <span><i className="fas fa-list"></i></span>Categories
          </NavLink>
          <NavLink to='feedback' onClick={enableBasePadding}>
            <span><i className="fas fa-comments"></i></span>Feedback
          </NavLink>
          <NavLink to='chat-monitor' onClick={enableBasePadding}>
            <span><i className="fas fa-headset"></i></span>Chat Monitor
          </NavLink>
        </ul>
        
        <div className="logout-section">
          <Box sx={{
            background: 'rgba(239, 68, 68, 0.1)',
            color: '#fca5a5',
            padding: '12px 16px',
            border: '1px solid rgba(239, 68, 68, 0.2)',
            textAlign: 'center',
            borderRadius: '12px',
            cursor: 'pointer',
            transition: 'all 0.3s ease',
            fontSize: '0.9rem',
            fontWeight: 500,
            '&:hover': {
              background: 'rgba(239, 68, 68, 0.2)',
              color: '#f87171',
              transform: 'translateY(-1px)',
              boxShadow: '0 4px 12px rgba(239, 68, 68, 0.2)'
            }
          }} 
          onClick={() => {SessionManager.shared.signOutAdmin(); navigate("/")}}
          >
            <i className="fas fa-sign-out-alt" style={{ marginRight: '8px' }}></i>
            Logout Admin
          </Box>
        </div>
      </div>
      <div className={basePaddingDisable ? "admin-dashboard-right nopadding" : "admin-dashboard-right"}>
        <Routes>
          <Route path="/" element={<AdminRoute components={[AdminOverviewPage]}/>}/>
          <Route path="users" element={<AdminRoute components={[AdminUsersPage]}/>}/>
          <Route path="orders" element={<AdminRoute components={[AdminOrderPage]}/>}/>
          <Route path="promotions" element={<AdminRoute components={[AdminPromotionsPage]}/>}/>
          <Route path="seller-plans" element={<AdminRoute components={[AdminSellerPlansPage]}/>}/>
          <Route path="category-subcategory" element={<AdminRoute components={[AdminCategoriesPage]}/>}/>
          <Route path="feedback" element={<AdminRoute components={[AdminFeedbackPage]}/>}/>
          <Route path="chat-monitor" element={<AdminRoute components={[AdminChatMonitorPage]}/>}/>
        </Routes>
      </div>
    </section>
    </div>

  )
}

export default AdminDashboardBase